export enum EmailReplyStatus {
  ReplyNeeded = 1,
  ReplyNotNeeded = 2,
  ReplyItself = 3,
  ReplyTimeout = 4,
}
